class ContentVideo {
  constructor(contentfulNode) {
    this.title = contentfulNode?.title;
    this.embedUrl = contentfulNode?.embedUrl;
    this.videoDescription = contentfulNode?.videoDescription;
    this.type = 'CONTENT_VIDEO'
  }
}

export { ContentVideo };
